import styled from "@emotion/styled";
import colors from "../../styles/colors";
import { css } from "@emotion/react";
/**
 * Styled input field container.
 */
export const InputFieldContainer = styled.div `
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  width: 100%;
`;
/**
 * Styled icon div.
 */
export const StyledInputFieldIconSectionContainer = styled.div `
  padding: 0.75rem;
  border-bottom-right-radius: 0rem;
  border-top-right-radius: 0rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${colors["color-blue-70"]};
`;
export const StyledInputFieldIconSectionContainerUnfilled = styled.div `
  margin: 0.75rem;
  display: flex;
  align-items: center;
  justify-content: center;
`;
export const StyledIconContainer = styled.div `
  display: flex;
  width: 100%;
  border: 0.078rem solid ${colors["color-gray-100"]};
  background-color: ${(props) => props.disabled ? colors["color-gray-30"] : "transparent"};
  border-radius: 0.375rem;
  overflow: hidden;
  padding: 0rem;
  height: 2.25rem;
  width: ${(props) => (props.fullWidth ? "100%" : "16.75rem")};
  border: ${(props) => props.disabled
    ? `0.078rem solid ${colors["color-gray-30"]}`
    : `0.078rem solid ${colors["color-gray-100"]}`};

  :hover {
    box-shadow: ${(props) => props.disabled
    ? "none"
    : `0rem 0.125rem 0.25rem 0rem rgba(0, 0, 0, 0.1),
      0rem 0rem 0.063rem 0rem rgba(0, 0, 0, 0.28)`};
  }

  :focus-within {
    border: ${(props) => props.disabled
    ? `0.078rem solid ${colors["color-gray-30"]}`
    : `0.078rem solid ${colors["color-blue-120"]}`};
    box-shadow: ${(props) => props.disabled
    ? "none"
    : `0rem 0.125rem 0.25rem 0rem rgba(0, 112, 210, 0.15)`};
    background-color: ${colors["color-blue-30"]};
  }

  ${(props) => getCurrentStateInputField(props.showError, props.showWarning)}
`;
/**
 * Styled Input field component.
 */
export const InputField = styled.input `
  font-family: Inter;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  border: none;
  width: 100%;
  padding: 0rem 0.5rem;
  background-color: transparent;

  ::placeholder {
    color: ${(props) => getPlaceholderTextColor(props.showError, props.showWarning)};
  }

  :hover {
    ::placeholder {
      color: ${(props) => getPlaceholderTextColor(props.showError, props.showWarning)};
    }
  }

  :focus {
    outline-width: 0;
    background-color: transparent;
    border: none;
    box-shadow: none;

    ::placeholder {
      color: ${(props) => getPlaceholderTextColor(props.showError, props.showWarning)};
    }
  }

  :disabled {
    border: 0.078rem solid ${colors["color-gray-30"]};
    background-color: ${colors["color-gray-30"]};
    color: ${colors["color-gray-120"]};

    :hover {
      box-shadow: none;
      ::placeholder {
        color: ${colors["color-gray-120"]};
      }
    }
  }
`;
/**
 * Styled input field helper text.
 */
export const InputFieldHelperText = styled.div `
  font-family: Inter;
  font-weight: 500;
  font-size: 0.625rem;
  line-height: 1rem;
  color: ${colors["color-gray-140"]};
  margin-top: 0.25rem;

  ${(props) => getCurrentStateInputFieldLabel(props.showError, props.showWarning)}
`;
/**
 * Function to return css for current state of input field component.
 * @param {boolean} showError
 * @param {boolean} showWarning
 * @returns {string} updated css
 */
export function getCurrentStateInputField(showError, showWarning) {
    return showError || showWarning
        ? css `
        border: 0.078rem solid
          ${colors[showError ? "color-red-120" : "color-gold-100"]};

        :focus {
          border: 0.078rem solid
            ${colors[showError ? "color-red-120" : "color-gold-100"]};
          background-color: ${colors["color-white-100"]};
        }
        ::placeholder {
          color: ${colors[showError ? "color-red-160" : "color-gold-160"]};
        }
      `
        : null;
}
/**
 * Function to return css for error state for input field label component
 * @param {boolean} showError
 * @returns {string} updated css
 */
export function getCurrentStateInputFieldLabel(showError, showWarning) {
    return showError || showWarning
        ? css `
        color: ${colors[showError ? "color-red-160" : "color-gold-160"]};
      `
        : null;
}
/**
 * Function to return css for placeholder text for input field component
 * @param {boolean} showError
 * @param {boolean} showWarning
 * @param {boolean} onHover
 * @returns {string} updated css
 */
export function getPlaceholderTextColor(showError, showWarning) {
    if (showError)
        return colors["color-red-160"];
    else if (showWarning)
        return colors["color-gold-160"];
    else
        return colors["color-gray-100"];
}
//# sourceMappingURL=InputField.styled.js.map